"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timestampToDate = exports.observer = exports.listenersEmit = exports.interval = exports.handleNameRule = exports.handleButton = exports.getMD5 = exports.fuzzySearchFieldName = exports.formatDate = exports.formValidate = exports.formBtnHasPermi = exports.debounce = exports.alterNomenclature = void 0;
var _createForOfIteratorHelper2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _typeof2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/typeof.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.fill.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.parse.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _jsMd = _interopRequireDefault(require("js-md5"));
var _isEmpty = require("./data/is-empty.js");
var _dataTypeOf = require("./data/data-type-of.js");
/**
* @description: 在连续的操作中，无论进行了多长时间，只有某一次的操作后在指定的时间内没有再操作，这一次才被判定有效
* @param { Function } fun 触发回调执行的函数
* @param { Number } wait id字段 默认 'id'
* @param { Boolean } immediate 在开始还是结束处触发，如非特殊情况，一般默认为 true 即可
*/
var debounce = exports.debounce = function debounce(/* fun, wait = 1000, immediate = true */
) {
  var a = Array.prototype.slice.call(arguments);
  var fun = a[0];
  var tims = 300;
  // eslint-disable-next-line no-console
  if (typeof fun !== 'function') console.error('debounce\n当前方法第一个参数必须为一个 function！！');else {
    var funString = a[0].toString();
    /* 计算方法的字符串 MD5值 */
    var outMd5 = require('js-md5');
    if (typeof outMd5 === 'function') funString = outMd5(funString + (a[3] || ''));
    var wait = tims;
    var immediate = Boolean(a[2]);

    /* 数据类型转换，防止报错 */
    /* 如果第二个数据是布尔值，那就当他是 immediate */
    if (typeof a[1] === 'boolean') immediate = a[1];else if (typeof a[1] === 'number') wait = a[1];
    /* 如果第二个数据是字符串 通过parseInt 看他是否包涵数字 */else if (typeof a[1] === 'string' && parseInt(a[1], 10)) wait = parseInt(a[1], 10);

    /* 这里是防止在清空 sessionStorage 前刷新页面，导致代码一直判断处于防抖中 */
    var t = parseInt(sessionStorage.getItem(funString), 10);
    if (new Date().valueOf() - t >= wait * 1.5) sessionStorage.removeItem(funString);

    /* 防抖 */
    if (!sessionStorage.getItem(funString)) {
      sessionStorage.setItem(funString, new Date().valueOf());
      if (immediate) fun(funString);
      setTimeout(function () {
        if (!immediate) fun(funString);
        sessionStorage.removeItem(funString);
      }, wait);
    }
  }
};

/** 处理命名规则
  * @description: 处理命名规则
  * @param { String } name 需要处理的命名
  * @param { String } rule 命名规则 -- 【 ucc： 大驼峰，kc 或 '-' ：短横线， underline 或 '_' ：下划线 】
  * @return { String } 处理后的命名规则【默认小驼峰命名】
  */
var handleNameRule = exports.handleNameRule = function handleNameRule(name) {
  var rule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Camel-Case';
  if (!name || typeof name !== 'string') return '';
  /* 以名字中的 - _ 分割字符串成数组 */
  var names = name.split(/[-_]/g);
  /* 横杠命名和下划线命名 转换成 驼峰命名法 */
  var nameCCs = names.map(function (string, index) {
    return index ? string.split('').map(function (str, i) {
      return i ? str : str.toLocaleUpperCase();
    }).join('') : string;
  }).join('');

  /* 默认转换成驼峰命名法，如果要转换成其他的，那就 驼峰命名法 转换指定命名法 */
  // if (rule !== 'Camel-Case') return nameCCs.replace(/[A-Z]/g, str => rule + str.toLocaleLowerCase())
  if (['Upper-Camel-Case', 'upper-camel-case', 'UCC', 'ucc'].indexOf(rule) > -1) return nameCCs.split('').map(function (s, i) {
    return i === 0 ? s.toLocaleUpperCase() : s;
  }).join('');else if (['Kebab-Case', 'kebab-case', 'KC', 'kc'].indexOf(rule) > -1) return nameCCs.replace(/[A-Z]/g, function (str) {
    return '-' + str.toLocaleLowerCase();
  });else if (rule === 'underline') return nameCCs.replace(/[A-Z]/g, function (str) {
    return '_' + str.toLocaleLowerCase();
  });
  return nameCCs;
};

/** 修改命名法
  * @description: 修改命名法，默认横线命名法
  * @param { String } name 需要处理的命名
  * @param { String } rule 命名规则 -- [ small-hump 或 sh 小驼峰（默认）， large-hump 或 lh 大驼峰，'-' ：短横线， '_' ：下划线 ]，如果该参数是其他不属于可选值的文字或符号组成的字符串，将会用这个字符串拼接命名法（等于取代短横线命名法中的‘-’）
  * @return { String } 处理后的命名规则【默认小驼峰命名】
  */
var alterNomenclature = exports.alterNomenclature = function alterNomenclature(name) {
  var rule = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'sh';
  var a = (0, _isEmpty.isEmpty)(name, 'string');
  if ((0, _isEmpty.isEmpty)(a)) return null;
  var b = name === null || name === void 0 ? void 0 : name.replace(/[A-Z]+/g, function (s) {
    return '-' + s.toLocaleLowerCase();
  }).split(/[-_]/g).filter(function (s) {
    return s;
  }).join('-');

  // 判断是否是大驼峰
  var r1 = ['large', 'large-hump', 'lh'].includes(rule);
  // 判断是否是小驼峰
  var r2 = ['small', 'small-hump', 'sh', 'hump'].includes(rule) || !rule;
  if (r1 || r2) {
    /* 先直接生成大驼峰，大驼峰首字母小写就成了小驼峰 */
    var d = b.split('-').map(function (str) {
      return str[0].toLocaleUpperCase() + str.slice(1);
    }).join('');
    if (r1) return d;else return d[0].toLocaleLowerCase() + d.slice(1);
  } /* 方法默认生成的是短横线命名法 */else if (rule === '-') return b;
  /* 下划线命名法 */else if (rule === '_') return b.replace(/[-]/g, '_');
  /* 如果rule不属于任何命名法，那就用它做分隔符 */else return b.replace(/[-]/g, rule);
};

/** 测试字段名是否存在
 * @description: 模糊校验 只要同名的 驼峰、下划线、短横线，且不区分大小写
 *  input(name1): aaaBbbbCccc
 *  input(name2): aaa_bbbb_cccc true
 *                aaa_bbbb_Cccc true
 *                aaaBbbb_Cccc true
 *                aaabbbb_Cccc true
 *                aaabbbbcccc true
 *                Aaabbbbcccc true
 *                aaa_bbb_Cccc false
 *                aaa_bbbb__cccc false
 *                aaa_bbbb_-cccc false
 * @param { String } name1 作为判断的字段名字符串
 * @param { String | Array | Object } name2 需要对比的字段名字符串
 * @return { Boolean } 返回尺寸
 */
var fuzzySearchFieldName = exports.fuzzySearchFieldName = function fuzzySearchFieldName(name1, name2) {
  /* 先将字段名转换成下换线命名法 */
  var n1 = alterNomenclature(name1, '_');
  var n2 = [];
  if (Array.isArray(name2)) n2.push.apply(n2, (0, _toConsumableArray2.default)(name2));else if ((0, _typeof2.default)(name2) === 'object') n2.push.apply(n2, (0, _toConsumableArray2.default)(Object.keys(name2)));else n2.push(name2);

  /* aaa_bbb 转换为 (aaa)([_-]{0,1})(bbb) */
  var regex = n1
  /* 通过下划线分割命名规则 */.split('_')
  /* 让分割后的字符串 被包裹在 () 中 */.map(function (s) {
    return "(".concat(s, ")");
  })
  /* 用 ([_-]{0,1}) 连接 */.join('([_-]{0,1})');

  /* 正则表达式 /^(aaa)([_-]{0,1})(bbb)$/i */
  /* ([_-]{0,1}) 为匹配 [_-] 匹配 至多一次 */
  // eslint-disable-next-line no-eval
  var a = n2.map(function (n2s) {
    return eval("/^".concat(regex, "$/i")).test(n2s) ? n2s : false;
  });
  if (Array.isArray(name2)) return a;else if ((0, _typeof2.default)(name2) === 'object') return a.find(function (s) {
    return s;
  });
  return a[0];
};

/** 时间格式工具
 * @description: 输入时间字符串，将其转换成format 参数指定的 指定的时间格式
 * @param { Object } datetime 输入时间<br/>
 *   可输入参数: new Date()<br/>
 *   或者 可被 new Date(string) 处理的参数<br/>
 *   或者 new Date().valueOf() 生成的时间戳（13位时间戳）
 * @param { Object } format 时间格式化模板<br/>
 *   模板格式<br/>
 *   默认：'{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}:{sss}'<br/>
 *   花括号是必须的，中间包涵着的符号为返回的字符串中放置的时间<br/>
 *   '{yyyy}' 年<br/>
 *   '{MM}'   月<br/>
 *   '{dd}'   日<br/>
 *   '{HH}'   时（24小时制）<br/>
 *   '{hh}'   时（12小时制）<br/>
 *   '{mm}'   分<br/>
 *   '{ss}'   秒<br/>
 *   '{sss}'  毫秒<br/>
 *   可以：<br/>
 *    '{yyyy}年{MM}月{dd}日 {HH}:{mm}:{ss}:{sss}'<br/>
 *    '{yyyy}年{MM}月{dd}日<br/>
 *     {HH}:{mm}:{ss}:{sss}'
 * @return { String } 输入格式化后的时间字符串
 */

var formatDate = exports.formatDate = function formatDate(datetime, format) {
  var a = datetime;
  if (a === 'timestamp') return new Date().valueOf();else if ((0, _dataTypeOf.dataTypeOf)(a) !== 'date') {
    // 如果输入时间是一个 纯数字 且 长度为10的 字符串或数字，则整型处理（可能是后端传递过来的时间戳）
    if (/^[0-9]{10}$/.test(a)) a = new Date(parseInt(a, 10) * 1000);
    // 如果输入时间是一个 纯数字 且 长度小于13的 字符串或数字，则整型处理
    else if (/^[0-9]{0,13}$/.test(a)) a = new Date(parseInt(a, 10));
    // 如果直接 new Date(a) ,结果不为 Invalid Date
    else if (new Date(a) + '' !== 'Invalid Date') a = new Date(a);
    // 否则管你输入什么，都给换成当前时间
    else return false;
  }
  var b = {
    // 从 Date 对象以四位数字返回年份
    Y: a.getFullYear(),
    // 从 Date 对象返回月份 (0 ~ 11)
    M: a.getMonth() + 1,
    // 从 Date 对象返回一个月中的某一天 (1 ~ 31)
    D: a.getDate(),
    // 返回 Date 对象的小时 (0 ~ 23)
    h: a.getHours(),
    // 返回 Date 对象的分钟 (0 ~ 59)
    m: a.getMinutes(),
    // 返回 Date 对象的秒数 (0 ~ 59)
    s: a.getSeconds(),
    // 返回 Date 对象的毫秒(0 ~ 999)
    ss: a.getMilliseconds()
    // 从 Date 对象返回一周中的某一天 (0 ~ 6)，星期日为一周的第一天
    // a: a.getDay() ? a.getDay() : 7 // 这个是以周一为第一天
  };
  var c = format || '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}:{sss}';
  if (c === 'timestamp') return a.valueOf();
  return c.replace(/{(Y|y|M|W|w|D|d|H|h|m|sss|s|A|a)+}/g, function (result, k) {
    var r = result.replace(/\{|}/g, '');
    // 字符串长度返回
    var lf = function lf(s) {
      return (s + '').length >= 2;
    };
    // result 的长度
    var rl = lf(r);
    // 补零
    var zf = function zf(s) {
      return lf(s) ? s : '0' + s;
    };
    var kk = k.toLocaleLowerCase();

    /* 年 */
    if (k.toLocaleLowerCase() === 'y') return b[k.toLocaleUpperCase()];
    /* 月 */else if (k === 'M') return rl ? zf(b.M) : b.M;
    /* 日 */else if (kk === 'd') return rl || k === 'D' ? zf(b.D) : b.D;
    /* 分 */else if (kk === 'm') return rl ? zf(b.m) : b.m;
    /* 秒 */else if (kk === 's') return rl ? zf(b.s) : b.s;
    /* 毫秒 */else if (kk === 'sss') return new Array(3 - (b.ss + '').length).fill('0').join('') + b.ss;
    /* 12小时制 */else if (kk === 'a') {
      var ap = b.h < 12 ? 'am' : 'pm';
      return k === 'A' ? ap.toLocaleUpperCase() : ap;
    } /* 时 */else if (kk === 'h') {
      var h = b.h;
      if (k === 'h') h %= 12;
      var _ap = '';
      if (!_ap && k === 'h') _ap = (h < 12 ? 'am' : 'pm') + ' ';
      c.replace(/{(A|a)+}/g, function () {
        _ap = '';
      });
      return "".concat(_ap).concat(rl ? zf(h) : h);
    }
    return result;
  });
};

/** 时间戳 转 时间字符串
  * @description: 将时间戳转成 年月日格式
  * @param { Object } timestamp 输入时间
  * @param { Object } format 时间格式化模板
  * @return { String } 输入格式化后的时间字符串
  */
var timestampToDate = exports.timestampToDate = function timestampToDate(/* timestamp, format */
) {
  var _a$;
  var a = Array.prototype.slice.call(arguments);
  var d = a[0];
  var f = {
    /* 日 */d: 999999999,
    /* 时 */h: 24,
    /* 分 */m: 60,
    /* 秒 */s: 60,
    /* 毫秒 */ss: 1000
  };
  var t = {
    /* 毫秒 */ss: 0,
    /* 秒 */s: 0,
    /* 分 */m: 0,
    /* 时 */h: 0,
    /* 日 */d: 0
  };

  // eslint-disable-next-line no-unused-vars
  for (var k in t) {
    t[k] = d % f[k];
    d = parseInt(d / f[k], 10);
  }
  return formatDate("".concat(t.d, " ").concat(t.h, ":").concat(t.m, ":").concat(t.s, ":").concat(t.ss), (_a$ = a[1]) !== null && _a$ !== void 0 ? _a$ : '{dd}天{HH}时{mm}分{ss}秒{sss}');
};

/** 处理按钮
  * @description: 处理按钮
  * @param { Object } btn 按钮对象
  * @return { Object } 处理后的按钮对象
  */
var handleButton = exports.handleButton = function handleButton(btn) {
  // const a = wlUtilsIsJudge
  var b = (0, _objectSpread2.default)({
    show: true,
    render: true,
    loading: false,
    disabled: false
  }, btn);
  // console.log(b.name, b)
  // const c = [...arguments].slice(1)
  // const d = ['show', 'render', 'loading', 'disabled']

  // d.forEach(s => (typeof b[s] === 'function' && (b[`${s}Fun`] = b[s])))

  // // b.label ??= b.name ?? ''

  // // console.log(b.label, { ...b })

  // b.isPermi = a.isPermi(b, ...c)
  // b.render = a.isRender(b, ...c)
  // b.show = a.isShow(b, ...c)
  // b.loading = a.isLoading(b, ...c)
  // b.disabled = a.isDisabled(b, ...c)

  // b.isShow = function () {
  //   const g = this.show
  //   const h = typeof this.showFun === 'function' ? this.showFunFun(this) : true
  //   return g && h && this.isPermi
  // }

  // b.isRender = function () {
  //   const g = this.render
  //   const h = typeof this.renderFun === 'function' ? this.renderFun(this) : true
  //   return g && h && this.isPermi
  // }

  // b.isLoading = function () {
  //   const g = this.loading
  //   const h = typeof this.loadingFun === 'function' ? this.loadingFun(this) : false
  //   return g || h
  // }

  // b.isDisabled = function () {
  //   // if (this.name === '编辑')console.log(this.name, ...arguments);
  //   const g = this.disabled
  //   const h = typeof this.disabledFun === 'function' ? this.disabledFun(this) : false
  //   return g || h
  // }

  return b;
};

/** 权限校验
  * @description: 校验按钮是否有权限
  * @param { Object } btn 按钮对象
  * @return { Object } 处理后的按钮对象
  */
var formBtnHasPermi = exports.formBtnHasPermi = function formBtnHasPermi(btn) {
  return Array.isArray(btn.permi) && btn.permi.length > 0 ? this.hasPermi(btn.permi) : true;
};

/** 获取 MD5 唯一值
 * @description: 将数据类型转成字符串 然后获取其唯一值
 * @param { * } data 数据
 * @return { String } 生成的MD5
 */
var getMD5 = exports.getMD5 = function getMD5(data) {
  switch ((0, _typeof2.default)(data)) {
    case 'object':
      return (0, _jsMd.default)(JSON.stringify(data));
    case 'string':
      return (0, _jsMd.default)(data);
    case 'number':
      return (0, _jsMd.default)(data + '');
  }
  return null;
};

/** 监听 dom元素 变化
  * @description: 计算输入内容的MD5值
  * @param { * } dom 需要监听的dom元素，如果dom参数非dom对象 ，那么就改为监听windown对象
  * @param { * } option 监听器设置对象
  * @param { * } fun 当元素发生改变之后回调函数
  * @return { String } 返回计算后的MD5
  */
var observer = exports.observer = function observer(/* dom, option, fun */
) {
  // const b = arguments[1]
  var c = arguments[2];
  if ((0, _dataTypeOf.dataTypeOf)(arguments[1], true) === '[object Function]') c = arguments[1];else if ((0, _dataTypeOf.dataTypeOf)(arguments[0], true) === '[object Function]') c = arguments[0];

  // if (dataTypeOf(arguments[0], true) === '[object Object]') b = arguments[0]

  if ((0, _dataTypeOf.dataTypeOf)(arguments[0], true) === '[object HTMLDivElement]') {
    var a = arguments[0];
    var $observer = new ResizeObserver(function (x, y) {
      // eslint-disable-next-line no-unused-vars
      var _iterator = (0, _createForOfIteratorHelper2.default)(x),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var z = _step.value;
          typeof c === 'function' && c(z, x, y);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    $observer.observe(a);
    return $observer;
  } else {
    if (typeof c === 'function') {
      window.onresize = c;
      return window.onresize;
    }
  }
  return false;
};

/** 表单校验
  * @description: 表单校验
  * @param { Object | String } form 需要校验的表单组，可以是一个表单的ref , 或者直接是该表单的组件实例。如果该参数为方法的时候，那么将校验当前组件中所有的表单组件（包括子）
  * @param { Function } fun 当元素发生改变之后回调函数
  * @param { Function } fun1 当元素发生改变之后回调函数
  * @return { void }
  */
var formValidate = exports.formValidate = function formValidate(form, fun, fun1) {
  var _this = this;
  document.activeElement.blur();
  var a = [];
  var ff = null;
  if (Array.isArray(form)) a = form;else if (typeof form === 'string') a = form.split(',');
  // eslint-disable-next-line no-console
  else if (typeof form !== 'function') console.warn('formValidate 方法，form参数必须为<Object>或<String>类型');
  if (typeof fun === 'function') ff = fun;else if (typeof form === 'function') ff = form;
  if (form || fun) {
    // 表单组件
    var b = [];
    if (Array.isArray(a) && a.length > 0) {
      b = a.map(function (ref) {
        if (typeof ref === 'string') {
          var _getRefs = function getRefs(self) {
            // eslint-disable-next-line no-unused-vars
            for (var key in self === null || self === void 0 ? void 0 : self.$refs) {
              var _v$$el;
              var v = self === null || self === void 0 ? void 0 : self.$refs[key];
              if (!v) return false;else if (((_v$$el = v.$el) === null || _v$$el === void 0 ? void 0 : _v$$el.nodeName) === 'FORM') return v;
              _getRefs(v);
            }
            return false;
          };
          if (_this.$refs[ref].$el.nodeName === 'FORM') return _this.$refs[ref];else return _getRefs(_this.$refs[ref]);
        } else if (typeof ref.validate === 'function') return ref;
        return false;
      });
    } else {
      var _this$$el;
      var _g = function g(self) {
        // eslint-disable-next-line no-unused-vars
        for (var key in self === null || self === void 0 ? void 0 : self.$refs) {
          var _v$$el2;
          var v = self === null || self === void 0 ? void 0 : self.$refs[key];
          if (((_v$$el2 = v.$el) === null || _v$$el2 === void 0 ? void 0 : _v$$el2.nodeName) === 'FORM') b.push(v);
          _g(v);
        }
        Array.isArray(self.$children) && self.$children.forEach(function (v) {
          var _v$$el3;
          if (((_v$$el3 = v.$el) === null || _v$$el3 === void 0 ? void 0 : _v$$el3.nodeName) === 'FORM') b.push(v);
          _g(v);
        });
      };
      if (((_this$$el = this.$el) === null || _this$$el === void 0 ? void 0 : _this$$el.nodeName) === 'FORM') b.push(this);
      _g(this);
      // console.log(this, b)
    }

    // H函数
    var h = this.$createElement;
    // 错误提示
    var errMsg = [];
    var errObject = {};

    // 校验表单
    b.forEach(function (f) {
      f.validate(function (valid, o) {
        typeof fun1 === 'function' && fun1(valid, o);
        // 获取校验不通过的校验对象信息
        Object.assign(errObject, o);
      });
    });

    // 拼接错误提示
    // eslint-disable-next-line no-unused-vars
    for (var key in errObject) {
      var errObj = errObject[key];
      if (Array.isArray(errMsg)) {
        errObj.forEach(function (err) {
          // errMsg.push(h('p', `${err.field}: ${err.message}`))
          errMsg.push(h('p', "".concat(err.message)));
        });
      } else {
        errMsg.push(h('p', "".concat(errObj.field, ": ").concat(errObj.message)));
        errMsg.push(h('p', "".concat(errObj.message)));
      }
    }
    if (errMsg.length > 0) {
      this.$notify({
        title: '校验不通过',
        type: 'warning',
        // duration: 0,
        message: h('div', {
          style: 'color: teal;white-space: pre-wrap;'
        }, errMsg)
      });
    } else {
      typeof ff === 'function' && ff(true);
    }
  }
};

/** 获取父组件事件
  * @description: 主要是为了匹配大小驼峰命名、横线命名法，防止父组件传递驼峰命名，子组件却用横线命名的问题
  * @param { String } name 事件名称
  * @return { Boolean } 如果无法找到该方法 那就返回false
  */
var listenersEmit = exports.listenersEmit = function listenersEmit(name) {
  var _this2 = this;
  var a = Array.prototype.slice.call(arguments).slice(1);
  var b = ['$listeners', '$attrs', '$props'];
  var c = ['', 'sh', 'lh', '-', '_'];
  var e = function e(f, n) {
    return _this2[f][n ? alterNomenclature(name, n) : name];
  };

  // 测试方法
  // console.group(name)
  // const d = b.some(f => {
  //   console.group(f)
  //   const z = c.some(n => {
  //     console.group(n)
  //     const y = typeof e(f, n) === 'function' ? (e(f, n)(...a) || true) : false
  //     console.log(name, 1, y, f, n, e(f, n))
  //     console.groupEnd()
  //     return y
  //   })
  //   console.log(name, 2, z)
  //   console.groupEnd()
  //   return z
  // })
  // console.log(name, 3, d)
  // console.groupEnd()

  return b.some(function (f) {
    return c.some(function (n) {
      return typeof e(f, n) === 'function' ? e(f, n).apply(void 0, (0, _toConsumableArray2.default)(a)) || true : false;
    });
  });
};

/** 计数器
  * @description: 这个计数器的目的是为了防止刷新后，之前挂在的计数器没有清除导致多个计数器堆叠
  * @param { Function } fun 方法
  * @return { String } 计数器ID
  */
var interval = exports.interval = function interval() {
  var a = arguments[0];
  var b = getMD5(a.toString());
  var c = sessionStorage.getItem('intervalId');
  var d = {};
  if (c) d = JSON.parse(c);
  if (d[b]) clearInterval(d[b]);
  d[b] = setInterval.apply(void 0, arguments);
  sessionStorage.setItem('intervalId', JSON.stringify(d));
  return d[b];
};